/**
 * Labstep
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { OrganizationSAML } from 'labstep-web/models/organization-saml.model';
import type React from 'react';
import type { OrganizationSAMLActionCreateProps } from './types';

export const OrganizationSAMLActionCreate: React.FC<
  OrganizationSAMLActionCreateProps
> = ({ organization, actionComponentProps }) =>
  !organization.organization_saml ? (
    <EntityActionCreate
      parentId={organization.id}
      parentName={organization.entityName}
      entityName={OrganizationSAML.entityName}
      actionComponentProps={actionComponentProps}
    />
  ) : null;
